module.exports = __webpack_public_path__ + "static/media/max4d.4c557ddc.png";